export const ro = {
  'ad.label': 'Publicitate',
  'ad.sponsored_by': 'Sponsorizat de {advertiser}',
  'ad.visit': 'Vizitează',
  'cookies.preferences': 'Preferințe cookie',
  'cookies.title': 'Confidențialitatea ta, sub controlul tău',
  'cookies.description': 'Folosim stocarea necesară pentru ca Albambam să funcționeze. Activăm analitica sau marketingul doar cu permisiunea ta. O poți retrage oricând. Consultă',
  'cookies.privacy_link': 'Politica de confidențialitate',
  'cookies.close': 'Închide preferințele',
  'cookies.necessary': 'Necesare',
  'cookies.necessary_desc': 'Sesiune, securitate, limbă și preferințe de bază.',
  'cookies.analytics': 'Analitică',
  'cookies.analytics_desc': 'Măsurare anonimă a utilizării pentru îmbunătățirea serviciului.',
  'cookies.marketing': 'Marketing',
  'cookies.marketing_desc': 'Personalizarea reclamelor și măsurarea campaniilor.',
  'cookies.configure': 'Configurează',
  'cookies.reject': 'Respinge opționale',
  'cookies.save': 'Salvează selecția',
  'cookies.accept': 'Acceptă toate',
  'lang.selector_label': 'Limbă',
  'lang.changed': 'Limba a fost schimbată',
  'nav.home': 'Acasă',
  'nav.categories': 'Categorii',
  'nav.shorts': 'Shorts',
  'nav.friends': 'Prieteni',
  'nav.upload': 'Încarcă',
  'nav.profile': 'Profil',
  'nav.login': 'Intră',
  'common.signed_in': 'Autentificat',
  'common.error': 'Eroare',
  'topbar.search_placeholder': 'Caută videoclipuri, creatori...',
  'legal.terms': 'Termeni',
  'legal.privacy': 'Confidențialitate',
  'nav.admin': 'Administrare',
  'nav.logout': 'Deconectare',
  'admin.tab.payments': 'Plăți',
  'admin.payments.title': 'Plăți',
  'cats.title': 'Categorii',
  'cats.all': 'Toate',
  'cats.adult_title': 'Categorii +18',
  'cats.empty': 'Niciun videoclip în această categorie.',
  'friends.block_confirm': 'Blochezi acest prieten? Nu veți mai putea conversa sau să vă vedeți ca prieteni.',
  'friends.accepted': 'Acum sunteți prieteni!',
  'friends.title': 'Prieteni',
  'friends.subtitle': 'Doar cei care se urmăresc reciproc devin prieteni și pot conversa în privat.',
  'friends.unread_count_label': '{n} mesaje necitite',
  'friends.blocked_users_title': 'Utilizatori blocați',
  'friends.unblock_user': 'Deblochează',
  'friends.requests_title': 'Cereri de chat',
  'friends.request_badge': 'Cerere',
  'friends.request_accept': 'Acceptă',
  'friends.request_ignore': 'Ignoră',
  'friends.empty_title': 'Nu ai încă prieteni',
  'friends.empty_subtitle': 'Urmărește pe cineva și fii urmărit înapoi pentru a debloca chatul privat.',
  'friends.attach_image': 'Poză',
  'friends.shared_video_label': 'A distribuit un videoclip',
  'friends.select_conversation': 'Selectează un prieten pentru a începe conversația',
  'friends.block_user': 'Blochează',
  'friends.no_messages_yet': 'Niciun mesaj încă. Salut!',
  'friends.message_placeholder': 'Scrie un mesaj...',
  'section.trending': 'Tendințe',
  'section.shorts': 'Shorts',
  'section.for_you': 'Pentru tine',
  'home.hero.badge': 'Bine ai venit la Albambam',
  'home.hero.title_1': 'Videoclipuri scurte.',
  'home.hero.title_2': 'Creatori reali.',
  'home.hero.subtitle': 'Privește, distribuie și câștigă. Încarcă videoclipurile tale și descoperă talente noi în fiecare categorie.',
  'home.hero.cta_shorts': 'Vezi Shorts',
  'home.hero.cta_trending': 'Tendințe',
  'home.shorts.see_all': 'Vezi toate',
  'home.empty.title': 'Niciun videoclip încă',
  'home.empty.subtitle': 'Când creatorii încarcă conținut, va apărea aici.',
  'live.send_diamonds': 'Trimite diamante',
  'live.buy': 'Cumpără',
  'live.chat': 'Chat',
  'live.type_message': 'Scrie un mesaj...',
  'live.send': 'Trimite',
  'auth.success_google': 'Autentificat cu Google',
  'auth.fail_google': 'Sesiune Google nevalidă',
  'auth.success_login': 'Autentificat',
  'auth.success_register': 'Cont creat',
  'auth.login_tab': 'Intră',
  'auth.register_tab': 'Creează cont',
  'auth.email': 'E-mail',
  'auth.password': 'Parolă',
  'auth.submit_login_loading': 'Se intră...',
  'auth.submit_login': 'Intră',
  'auth.name': 'Nume',
  'auth.submit_register_loading': 'Se creează...',
  'auth.submit_register': 'Creează cont',
  'auth.or': 'sau',
  'legal.privacy_title': 'Politica de confidențialitate',
  'search.title': 'Rezultate pentru „{q}"',
  'search.count': '{n} videoclipuri',
  'search.empty': 'Niciun rezultat.',
  'series.load_error': 'Serialul nu a putut fi încărcat',
  'series.unlocked': 'Serial deblocat',
  'series.purchase_error': 'Achiziția nu a putut fi inițiată',
  'series.restricted': 'Acces restricționat',
  'series.configure_access': 'Configurează accesul',
  'series.language_all': 'Toate limbile',
  'series.episode_count': '{n} episoade',
  'series.buy': 'Cumpără serialul',
  'series.filter_language': 'Filtrează după limbă',
  'series.no_episodes': 'Niciun episod publicat încă.',
  'series.episode_number': 'Episodul {n}',
  'legal.terms_title': 'Termeni și condiții',
  'lang.ca': 'Catalană',
  'lang.en': 'Engleză',
  'lang.es': 'Spaniolă',
  'lang.fr': 'Franceză',
  'lang.de': 'Germană',
  'lang.it': 'Italiană',
  'lang.eu': 'Bască',
  'lang.gl': 'Galiciană',
  'lang.zh': 'Chineză',
  'lang.other': 'Altele',
  'lang.vi': 'Vietnameză',
  'lang.ja': 'Japoneză',
  'lang.ko': 'Coreeană',
  'lang.ru': 'Rusă',
  'lang.ro': 'Română',
  'lang.ar': 'Arabă',
  'lang.tr': 'Turcă',
  'lang.pl': 'Poloneză',
  'lang.ms': 'Malaeză',
  'lang.ta': 'Tamilă',
  'upload.series_title_error': 'Scrie titlul serialului',
  'upload.series_adult_category_error': 'Selectează o categorie +18 pentru serial',
  'upload.series_created': 'Serial creat',
  'upload.series_create_error': 'Serialul nu a putut fi creat',
  'upload.err_file': 'Alege un fișier video valid',
  'upload.err_title': 'Pune un titlu',
  'upload.series_select_error': 'Selectează sau creează un serial',
  'upload.trailer_target_error': 'Selectează videoclipul sau serialul trailerului',
  'upload.price_error': 'Introdu un preț valid de cel puțin 0,50 EUR.',
  'upload.adult_category_error': 'Selectează o categorie adulți',
  'upload.success': 'Videoclip încărcat cu succes',
  'upload.title_h': 'Încarcă un videoclip',
  'upload.kind': 'Tip de publicare',
  'upload.kind_video': 'Videoclip independent',
  'upload.kind_episode': 'Episod al unui serial',
  'upload.kind_trailer': 'Trailer public în Shorts',
  'upload.series': 'Serial',
  'upload.series_select': 'Selectează un serial',
  'upload.episode': 'Episod',
  'upload.series_new_title': 'Titlul unui serial nou',
  'upload.series_create': 'Creează serial',
  'upload.series_adult': 'Serial +18',
  'upload.series_premium': 'Serial premium',
  'upload.series_adult_category': 'Categoria +18 a serialului',
  'upload.series_price': 'Preț per episod și pachet (EUR)',
  'upload.trailer_for': 'Trailerul prezintă',
  'upload.trailer_select': 'Selectează videoclip sau serial',
  'upload.video_prefix': 'Videoclip',
  'upload.file_label': 'Fișier video (MP4, max 1GB)',
  'upload.file_pick': 'Apasă pentru a alege un videoclip',
  'upload.thumb_label': 'Miniatură (opțional)',
  'upload.video_title': 'Titlu',
  'upload.description': 'Descriere',
  'upload.category': 'Categorie',
  'upload.is_short': 'Este un Short (vertical)',
  'upload.paid_video': 'Videoclip cu plată',
  'upload.adult_content': 'Conținut +18',
  'upload.video_language': 'Limba videoclipului',
  'upload.individual_price': 'Preț pentru vizionarea acestui videoclip (EUR)',
  'upload.paid_video_help': 'Privitorul cumpără acces permanent doar la acest videoclip. Prețul minim este 0,50 EUR.',
  'upload.adult_category': 'Categorie adulți',
  'upload.uploading': 'Se încarcă {n}%',
  'upload.submit': 'Încarcă videoclipul',
  'user.followers': 'urmăritori',
  'user.following': 'urmăriți',
  'user.follow': 'Urmărește',
  'user.chat_open': 'Conversează',
  'user.request_sent': 'Cerere trimisă',
  'user.send_message': 'Trimite mesaj',
  'user.followers_title': 'Urmăritori',
  'user.following_title': 'Urmăriți',
  'user.unfollow': 'Nu mai urmări',
  'user.request_title': 'Cerere de chat',
  'user.request_subtitle': 'Poți trimite un singur mesaj. Dacă acceptă cererea, veți deveni prieteni și veți putea conversa.',
  'user.request_placeholder': 'Scrie mesajul tău...',
  'user.request_send': 'Trimite cererea',
  'shorts.login_for_like': 'Autentifică-te pentru a aprecia',
  'watch.share_copied': 'Link copiat',
  'watch.delete_confirm': 'Ștergi acest comentariu?',
  'ad.skip_in': 'Sari peste în {n}s',
  'ad.skip': 'Sari peste reclamă',
  'watch.share': 'Distribuie',
  'friends.share_video': 'Distribuie un videoclip',
  'friends.send': 'Trimite',
  'watch.comments': 'Comentarii',
  'watch.write_comment': 'Scrie un comentariu...',
  'watch.publish': 'Publică',
  'watch.login_to_comment': 'Trebuie să te autentifici pentru a comenta.',
  'watch.login_btn': 'Intră pentru a comenta',
  'watch.no_comments': 'Niciun comentariu încă.',
  'watch.related': 'Similare',
  'nav.trending': 'Tendințe',
  'friends.follow_option_only_follow': 'Urmărește',
  'friends.follow_option_friends': 'Prieteni',
  'watch.like': 'Îmi place',
  'watch.views_short': '{n} vizionări',
  'shorts.empty.title': 'Niciun Short încă',
  'shorts.empty.subtitle': 'Încarcă un videoclip scurt pentru a deschide secțiunea.',
  'shorts.share': 'Distribuie',
  'auth.continue_google': 'Continuă cu Google',
  'upload.is_premium': 'Premium',
  'upload.price': 'Preț (€)',
  'upload.err_select': 'Alege un videoclip',
  'profile.upload_btn': 'Încarcă videoclip',
  'profile.tab_videos': 'Videoclipurile mele ({n})',
  'profile.tab_history': 'Istoric',
  'profile.tab_recos': 'Recomandări',
  'profile.no_videos': 'Nu ai încărcat încă niciun videoclip.',
  'profile.no_history': 'Nu ai vizionat încă niciun videoclip.',
  'profile.no_recos': 'Privește câteva videoclipuri pentru a primi recomandări.',
  'profile.likes': 'aprecieri',
  'profile.views': 'vizionări',
  'wallet.title': 'Portofel',
  'wallet.rate_label': 'Rată',
  'wallet.min_label': 'Minim de retragere',
  'wallet.amount_label': 'Suma de retras',
  'wallet.withdraw_btn': 'Solicită retragere',
  'wallet.history_title': 'Istoricul solicitărilor',
  'wallet.success': 'Solicitare creată',
  'wallet.bad_amount': 'Sumă nevalidă',
  'wallet.per_view': '{rate} {cur}/vizionare',
  'admin.title': 'Administrare',
  'admin.stats.users': 'Utilizatori',
  'admin.stats.videos': 'Videoclipuri',
  'admin.stats.shorts': 'Shorts',
  'admin.stats.views': 'Vizionări',
  'admin.tab.videos': 'Videoclipuri',
  'admin.tab.ads': 'Reclame',
  'admin.tab.users': 'Utilizatori',
  'admin.tab.withdrawals': 'Retrageri',
  'admin.tab.config': 'Setări',
  'admin.tab.translations': 'Limbi',
  'tbl.title': 'Titlu',
  'tbl.creator': 'Creator',
  'tbl.category': 'Categorie',
  'tbl.type': 'Tip',
  'tbl.views': 'Vizionări',
  'tbl.likes': 'Aprecieri',
  'tbl.status': 'Stare',
  'tbl.actions': 'Acțiuni',
  'tbl.placement': 'Poziție',
  'tbl.advertiser': 'Anunțător',
  'tbl.impressions': 'Imp.',
  'tbl.clicks': 'Clicuri',
  'tbl.active': 'Activ',
  'tbl.name': 'Nume',
  'tbl.email': 'E-mail',
  'tbl.role': 'Rol',
  'tbl.wallet': 'Portofel',
  'tbl.amount': 'Sumă',
  'tbl.date': 'Dată',
  'tbl.user': 'Utilizator',
  'video.video': 'Videoclip',
  'video.short': 'Short',
  'action.show': 'Publică',
  'action.hide': 'Ascunde',
  'action.delete_confirm_video': 'Ștergi videoclipul?',
  'ad.create_h': 'Creează reclamă',
  'ad.title_label': 'Titlu',
  'ad.image_label': 'URL imagine',
  'ad.target_label': 'URL destinație',
  'ad.advertiser_label': 'Anunțător',
  'ad.placement_label': 'Plasare',
  'ad.placement.banner': 'Banner (site)',
  'ad.placement.preroll': 'Pre-roll (înainte de videoclip)',
  'ad.placement.overlay': 'Overlay (în videoclip)',
  'ad.active': 'Activ',
  'ad.create_btn': 'Creează',
  'ad.success_create': 'Reclamă creată',
  'ad.delete_confirm': 'Ștergi reclama?',
  'users.make_admin': 'Fă admin',
  'users.remove_admin': 'Scoate admin',
  'wd.approve': 'Aprobă',
  'wd.reject': 'Respinge',
  'wd.mark_paid': 'Marchează plătit',
  'wd.empty': 'Nicio solicitare',
  'cfg.title': 'Setări de plăți',
  'cfg.rate_label': 'Plată per vizionare ({cur})',
  'cfg.min_label': 'Minim pentru retragere ({cur})',
  'cfg.currency': 'Monedă',
  'cfg.save': 'Salvează',
  'cfg.saved': 'Setări salvate',
  'trans.title': 'Limbi și traduceri',
  'trans.intro': 'Încarcă un fișier JSON cu traduceri pentru orice cod de limbă (ex. ja, pt, zh). Fișierul trebuie să conțină o mapare plată cheie → text.',
  'trans.code_label': 'Cod de limbă (ex. ja, pt-BR, zh)',
  'trans.name_label': 'Nume (în acea limbă)',
  'trans.file_label': 'Fișier JSON de traduceri',
  'trans.upload': 'Încarcă',
  'trans.uploaded': 'Traduceri salvate',
  'trans.delete': 'Șterge',
  'trans.delete_confirm': 'Ștergi această limbă?',
  'trans.builtin': 'Încorporat',
  'trans.custom': 'Personalizat',
  'trans.empty_custom': 'Nicio limbă personalizată încă.',
  'common.cancel': 'Anulează',
  'common.loading': 'Se încarcă...',
  'common.too_fast': 'Prea repede, așteaptă puțin',
  'time.few_seconds': 'acum câteva secunde',
  'time.min': 'acum {n} min',
  'time.h': 'acum {n} h',
  'time.d': 'acum {n} z',
  'time.w': 'acum {n} săpt',
  'time.mo': 'acum {n} luni',
  'time.y': 'acum {n} ani',
  'brand.tagline': 'Videoclipuri scurte. Creatori reali.',
  'live.section': 'În direct',
  'live.start': 'Începe un live',
  'live.end': 'Încheie live-ul',
  'live.join': 'Intră în direct',
  'live.chat_placeholder': 'Scrie un mesaj...',
  'live.diamond': 'Diamant',
  'live.buy_access': 'Cumpără acces',
  'live.save_recording': 'Salvează înregistrarea',
};
